module.exports = __webpack_public_path__ + "img/Fieldkit_Panel 01_Final_clouds_sized.4818b2fa.png";